import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const noticeFromTCTService = {};

// Thông báo từ TCT
noticeFromTCTService.listNotice = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/message-taxorgs`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

export default noticeFromTCTService;
